/*
 * Copyright (c) 2026 Paxia AI Pty Ltd. All rights reserved.
 * This software is proprietary and confidential.
 * No part of this codebase may be copied, modified, published, distributed, sublicensed, or used without prior written permission from Paxia AI Pty Ltd.
 */

/* eslint-disable react-refresh/only-export-components */
import React, { useEffect, useState, useMemo } from 'react';
import { getBuilderSchema } from '../api/botsApi';
import { StrategySchemaV2Context } from './StrategySchemaV2ContextBase';
import { hashJson, normalize } from './StrategySchemaV2Utils';

export const StrategySchemaV2Provider = ({ children }) => {
  const [rawSchema, setRawSchema] = useState(null);
  const [schemaHash, setSchemaHash] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        setLoading(true);
        const response = await getBuilderSchema();
        const data = response?.data || response; // backend may already unwrap
        if (!mounted) return;
        setRawSchema(data);
        try {
          const h = await hashJson(data);
          if (!mounted) return;
          setSchemaHash(h);
          const prev = localStorage.getItem('strategySchemaHash');
            if (prev && prev !== h) {
              // Flag for consumer UI
              console.info('Schema hash changed', prev, '->', h);
            }
            localStorage.setItem('strategySchemaHash', h);
        } catch (hashErr) {
          console.warn('Failed to hash schema', hashErr);
        }
      } catch (e) {
        if (mounted) setError(e);
      } finally {
        if (mounted) setLoading(false);
      }
    })();
    return () => { mounted = false; };
  }, []);

  const normalized = useMemo(() => normalize(rawSchema), [rawSchema]);

  const unified = useMemo(() => ([...(normalized.indicators||[]), ...(normalized.operators||[]), ...(normalized.actions||[])]), [normalized]);

  const value = useMemo(() => ({ rawSchema, normalized, unified, schemaHash, loading, error }), [rawSchema, normalized, unified, schemaHash, loading, error]);

  return (
    <StrategySchemaV2Context.Provider value={value}>
      {children}
    </StrategySchemaV2Context.Provider>
  );
};
